import { NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { RouterModule } from "@angular/router";

import { ButtonModule } from "primeng/button";
import { RippleModule } from "primeng/ripple";
import { TooltipModule } from "primeng/tooltip";

/**
 * ButtonComponent is a reusable button component that supports different types, icons, labels, and routing.
 */
@Component({
  selector: "app-btn",
  imports: [RouterModule, ButtonModule, RippleModule, TooltipModule, NgTemplateOutlet],
  templateUrl: "./button.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { "[class.block]": "fluid()" },
})
export class ButtonComponent {
  type = input<"primary" | "secondary">("primary");
  icon = input<string>();
  label = input<string>();
  size = input<"small" | undefined | "large">(undefined);
  linkUrl = input<string>();
  /** Accessible name when the visible label does not say enough (e.g. "Retirer" for which product). */
  ariaLabel = input<string>();
  tooltipLabel = input<string>("");
  tooltipPosition = input<"top" | "bottom" | "left" | "right">("right");
  /** Disables the button (it is then skipped by the keyboard and cannot be tapped). */
  disabled = input<boolean>(false);
  /** Takes the full width of its container (e.g. aligned buttons in a table column). */
  fluid = input<boolean>(false);

  tooltipOpt = { showDelay: 800 };
}
